import { ExperienceTransferListItem, ExperienceTransferSearchModel } from './types-store';

export const ACTION = {
  CLEAR_LIST: 'EXPERIENCE_TRANSFER_LIST:CLEAR_LIST',

  REQUEST_LIST: 'EXPERIENCE_TRANSFER_LIST:REQUEST_LIST',
  RECEIVE_LIST: 'EXPERIENCE_TRANSFER_LIST:RECEIVE_LIST',
  FAIL_LIST: 'EXPERIENCE_TRANSFER_LIST:FAIL_LIST',

  REQUEST_DELETE: 'EXPERIENCE_TRANSFER_LIST:REQUEST_DELETE',
  RECEIVE_DELETE: 'EXPERIENCE_TRANSFER_LIST:RECEIVE_DELETE',
  FAIL_DELETE: 'EXPERIENCE_TRANSFER_LIST:FAIL_DELETE'
};

export class ClearList {
  public type: string = ACTION.CLEAR_LIST;
  constructor(public requestId: number) { }
}

export class RequestList {
  public type: string = ACTION.REQUEST_LIST;
  constructor(public requestId: number, public model: ExperienceTransferSearchModel, public clearResults: boolean) { }
}

export class ReceiveList {
  public type: string = ACTION.RECEIVE_LIST;
  constructor(public requestId: number, public list: ExperienceTransferListItem[], public numberOfResults: number) { }
}

export class FailList {
  public type: string = ACTION.FAIL_LIST;
  constructor(public requestId: number) { }
}

export class RequestDeleteExperienceTransfer {
  public type: string = ACTION.REQUEST_DELETE;
  constructor(public id: number) { }
}

export class ReceiveDeleteExperienceTransfer {
  public type: string = ACTION.RECEIVE_DELETE;
  constructor(public id: number) { }
}

export class FailDeleteExperienceTransfer {
  public type: string = ACTION.FAIL_DELETE;
  constructor(public id: number) { }
}
